import {ModuleWithProviders, NgModule} from "@angular/core";
import {DxInMemoryDB} from "./services/dx-in-memory-db";
import {HttpClientInMemoryWebApiModule, InMemoryBackendConfigArgs} from "angular-in-memory-web-api";
import {HttpClientModule} from "@angular/common/http";
import {DX_IN_MEMORY_BACKEND_CONFIG, DxInMemoryBackendConfig} from "./config/dx-in-memory-backend-config";


/** Конфигурация in-memory бэкэнда **/
export const IN_MEMORY_WEB_API_CONFIG = {
  apiBase: 'dx-fake-api/',
  delay: 5,
  dataEncapsulation: false,
  passThruUnknownUrl: true
};


/**
 *   DxInMemoryBackendModule - модуль содержит функцинал для эмуляции бэкэнда.
 *
 *   Причина вынесения данной функциональности из ядра такова:
 *   1. Нет адекватного способа передачи environment в суб-модуль, так чтобы при помощи данных из
 *      environment можно было бы сделать условный импорт в секции imports[].
 *      Это реально сделать только определив алиас @env для путей расположения environment в приложении,
 *      импортировавшем ядро. А это своего рода костыль.
 *
 *   2. По-факту ин-мемори бэкенд нужен длеко не во всех случаях, поэтому нет смысла тащить его с ядром.
 *
 **/
@NgModule({
  declarations: [],
  exports: [],
  imports: [
    HttpClientModule,
    HttpClientInMemoryWebApiModule.forRoot(DxInMemoryDB, <InMemoryBackendConfigArgs> IN_MEMORY_WEB_API_CONFIG)
  ],
  providers: [DxInMemoryDB],
  bootstrap: []
})
export class DxInMemoryBackendModule {
  // public static forRoot(config: DxInMemoryBackendConfig | null | undefined): ModuleWithProviders {
  //   return {
  //     ngModule: DxInMemoryBackendModule,
  //     providers: [
  //       {
  //         provide: DX_IN_MEMORY_BACKEND_CONFIG,
  //         useValue: config || {}
  //       },
  //       DxInMemoryDB
  //     ]
  //   };
  // }
}
